import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { customerOperations } from '../stores/customer-store'
import { AccountService } from '../services/account-service'
import { errorToast, successToast } from '../toaster'
import { donePromise } from '../utils'
import { BillingAccount } from 'src/types'
import { CustomersNavQueries } from 'src/modules/customers-nav/customers-nav.queries'

interface Billing extends BillingAccount {
  billingInfo: null;
  user: { firstName: string, lastName: string, termsOfService: boolean };
}

@Injectable({providedIn: 'root'})
export class AccountActions {
  accountService: AccountService = new AccountService();

  constructor(private customersNavQueries: CustomersNavQueries) {}

  loadAccount(): Promise<any> {
    const p = this.accountService.getAccount().then(account => {
      if (account) {
        reactor.dispatch(customerOperations.setAccount, account)
      }
    }).catch(err => {
      errorToast("Account failed to load")
    })
    return donePromise(p)
  }

  updateAccount(body: object): Promise<any> {
    const p = this.accountService.updateAccount(body).then(() => {
      // Remove after agency signup uses apollo
      this.customersNavQueries.refetchUser().subscribe()

      reactor.dispatch(customerOperations.updateAccount, body)
      successToast("Account updated successfully.")
    }).catch(() => {
      errorToast("Failed to update account, please try again later.")
    })
    return p
  }

  loadBillingAccount(): Promise<any> {
    const p = this.accountService.getBillingAccount().then(billingAccount => {
      reactor.dispatch(customerOperations.setBillingAccount, billingAccount)
    }).catch(() => {
      errorToast("Failed to load billing info")
    })
    return donePromise(p)
  }

  updateBillingAccount(body: Billing): Promise<any> {
    const p = this.accountService.updateBillingAccount(body).then(() => {
      successToast('Billing info securely saved')
    }).catch(res => {
      errorToast(res.status === 500 ? 'Apologies, we are having server problems. Please try again later.' : 'The following errors were encountered when saving your information.')
      throw res // propagate error
    })
    return p
  }

  createBillingAccount(body: Billing): Promise<any> {
    const p = this.accountService.createBillingAccount(body).then(() => {
      // Activate called after creating billing account
    }).catch(res => {
      errorToast(res.status === 500 ? 'Apologies, we are having server problems. Please try again later.' : 'The following errors were encountered when saving your information.')
      throw res // propagate error
    })
    return p
  }

  // Activates all customer subscriptions - should only be called on signup
  activate(): Promise<any> {
    const p = this.accountService.activate().then(() => {
      successToast('Finished! Successfully activated your account.')
    }).catch(res => {
      errorToast(res && res.body && res.body.message ? res.body.message : 'Something went wrong activating your account. We apologize, please try again later.')
    })
    return p
  }
}

